import { authAPI } from "../api/api";

const SET_USER_DATA = 'auth/SET_USER_DATA'
const SET_LOGIN = 'auth/SET_LOGIN'
const SET_LOGOUT = 'auth/SET_LOGOUT'
const AUTH_ERROR = 'auth/AUTH_ERROR'


let initialState = {
  userId: null,
  email: null,
  login: null,
  isAuth: false,
  error: null
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_DATA:
      return ({
        ...state,
        ...action.data,
        isAuth: true,
      });
    case SET_LOGIN:
      return ({
        ...state,
        userId: action.userId
      });
    case AUTH_ERROR:
      return ({
        ...state,
        error: action.error
      });
    case SET_LOGOUT:
      return ({
        ...initialState
      });
    default:
      return state;
  }
}

const setUserData = (userId, email, login) => ({ type: SET_USER_DATA, data: { userId, email, login } })
const setLogin = (userId) => ({ type: SET_LOGIN, userId })
const setLogout = () => ({ type: SET_LOGOUT })
const getError = (error) => ({ type: AUTH_ERROR, error })

export const getUserData = () => async (dispatch) => {
  let response = await authAPI.me()
  if (response.resultCode === 0) {
    let { id, login, email } = response.data;
    dispatch(setUserData(id, email, login))
  } return false
}


export const getLogin = (object) => async (dispatch) => {
  let [data, response] = [await authAPI.logIn(object), await authAPI.me()]

  if (data.data.resultCode === 0) {
    dispatch(setLogin(data.data.data.userId));
    let { id, login, email } = response.data;
    dispatch(setUserData(id, email, login))
  } else if (data.data.resultCode === 1) {
    dispatch(getError('Email or password are wrong'))
  }
}

export const getLogout = () => async (dispatch) => {
  await authAPI.logout()
  dispatch(setLogout())
}

export default authReducer;